<template>
    <div class="main__news-detail news-detail">
      <div class="news-detail__container container container_1">
        <div class="news-detail__wrapper">
          <div class="news-detail__heading">
            <h1 class="news-detail__title text-32 text-semibold"
                @click="next()">
              {{programParams.program.name}}
            </h1>
            <div class="news-detail__date text-12 text-bold text-button">{{programParams.program.duration}}</div>
          </div>

          <div class="news-detail__content text-15" v-html="programParams.program.description"></div>

          <div class="news-detail__buttons">
            <template
                v-if="programParams.currentProgramIndex + 1 < programParams.programs.length">
              <a
                  class="news-detail__button text-15 text-bold text-button button-common"
                  :href="'/umnaya_sportivnaya_ploshchadka/' + programParams.programs[programParams.currentProgramIndex + 1].code">
                Следующая программа
              </a>
            </template>
            <a href="/umnaya_sportivnaya_ploshchadka/" class="news-detail__button text-15 text-bold text-button button-border">Назад</a>
          </div>
        </div>
        <div
            :style="[programParams.program.exercises_list === false ? {display: 'none'} : {marginTop: '64px'}]"
        >
          <h2 class="news-list__title text-32 text-semibold title-link">Другие тренировки</h2>
          <ul class="news-list__list">
            <li class="news-list__item news-list-item news-list-item_high" v-for="(exercise, exerciseIndex) in programParams.program.exercises" :key="exercise.code">

              <router-link class="news-list-item__link"  :to="{ name: 'exercise', params: {
            programCode: programParams.programCode,
            exerciseCode: exercise.code,

            program: programParams.program,
            exercises: programParams.program.exercises,
            exercise: exercise,
            currentExerciseIndex: exerciseIndex,
          }}">
                <div class="news-list-item__img">
                  <img :src="exercise.image" :alt="exercise.name">
                </div>
                <div class="news-list-item__frame">
                  <h3 class="news-list-item__text text-18 text-semibold">
                    {{exercise.name}}
                  </h3>
                </div>
              </router-link>

            </li>
          </ul>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'ProgramView',
  components: {
  },
  data() {
    return {
      currentProgramIndex: null,
      programs : null,
      programParams : {},
    }
  },
  beforeMount() {

    let that = this;

    this.axios.get('https://sfsi.ru/api/smart-workout/all')
        .then((response) => {
          that.programSections = response.data;
          let sections = response.data;
          sections.forEach((section) => {
            let programs = section.programs;
            that.programParams.programs = programs;
            let programCounter = 0;
            programs.forEach((program) => {
              if (that.$route.params.programCode == program.code) {
                that.programParams.programCode = program.code;
                that.programParams.program = program;
                that.programParams.currentProgramIndex = programCounter;
                that.$forceUpdate();
              }
              programCounter++;
            })
          })
        })



  },
  updated () {
    console.log('updated!')
  }
}
</script>
